module.exports = __webpack_public_path__ + "static/media/Customized CBON network infographic - CBON - 24-07-2024 N .19e3f124.gif";